import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initSentry } from "./lib/observability/sentry";

initSentry();

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary
    fallback={({ resetError }) => (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: 24,
          fontFamily: "system-ui, sans-serif",
        }}
      >
        <h1 style={{ marginBottom: 12 }}>Something went wrong</h1>
        <p style={{ marginBottom: 24, color: "#666" }}>
          The error was reported. Try reloading.
        </p>
        <button
          onClick={resetError}
          style={{
            padding: "8px 16px",
            borderRadius: 6,
            border: 0,
            background:
              "linear-gradient(90deg, #FF68C3 0%, #FFA98B 100%)",
            color: "#fff",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          Retry
        </button>
      </div>
    )}
  >
    <App />
  </Sentry.ErrorBoundary>,
);
